import React, { memo } from 'react';
import Letter from './Letter';
import { buildLetterId } from '../../../../../../util/find-the-letter-util';
import makeStyles from '@mui/styles/makeStyles';

const Sentence: React.FC<any> = ({ description, pageNumber, activityLetter }) => {
  const classes = useStyles();
  const sentenceData = description?.split(' ')?.map((word: string) => word + '  ') ?? [];

  return (
    <div className={classes.wrapper}>
      {sentenceData.map((word: string, wordIndex: number) => (
        <span key={wordIndex}>
          {word.split('').map((eachLetter: string, letterIndex: number) => (
            <Letter
              page={pageNumber}
              letter={eachLetter}
              key={`${wordIndex} ${letterIndex}`}
              letterId={buildLetterId(wordIndex, letterIndex)}
              activityLetter={activityLetter}
            />
          ))}
        </span>
      ))}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: '90vw',
  },
}));

export default memo(Sentence);
